<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-input class="search-el" size="small" v-model="query.name" placeholder="姓名"></el-input>
        <el-input class="search-el" size="small" v-model="query.phone_number" placeholder="电话"></el-input>
        <el-input class="search-el" size="small" v-model="query.wechat_number" placeholder="微信号"></el-input>
        <el-button type="primary" size="small" @click="getList()"> 查询 </el-button>
        <el-button type="primary" size="small" @click="exportList()">
          导出
        </el-button>
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column prop="mobile_phone" label="账户手机号"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="education" label="学历"></el-table-column>
        <el-table-column prop="phone_number" label="电话"></el-table-column>
        <el-table-column prop="wechat_number" label="微信号"></el-table-column>
        <el-table-column prop="mailbox" label="邮箱"></el-table-column>

        <el-table-column prop="media_account" label="个人媒体账号"></el-table-column>
        <el-table-column prop="platform" label="个人媒体平台"></el-table-column>

        <el-table-column prop="experience" label="授课经验"></el-table-column>

        <el-table-column prop="study_experience" label="学习经历"></el-table-column>
        <el-table-column prop="training_passage" label="受训经历"></el-table-column>
        <el-table-column prop="zhangdefen_story" label="学习或了解过灵动生活课程"></el-table-column>
        
        <!-- <el-table-column label="学历证书扫描件">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="showImg(row.academic_certificate)">查看</el-button>
            <el-button type="primary" size="small" @click="downloadImg(row.academic_certificate)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column label="学历证明扫描件">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="showImg(row.studying_certificate)">查看</el-button>
            <el-button type="primary" size="small" @click="downloadImg(row.studying_certificate)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column label="相关资质证书扫描件">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="showImg(row.qualification_certificate)">查看</el-button>
            <el-button type="primary" size="small" @click="downloadImg(row.qualification_certificate)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column label="身份证扫描件">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="showImg(row.identification_paper)">查看</el-button>
            <el-button type="primary" size="small" @click="downloadImg(row.identification_paper)">下载</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="registration_video" label="报名视频">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="showVideo(row.registration_video)">查看</el-button>
            <el-button type="primary" size="small" @click="downloadImg([row.registration_video])">下载</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="created_at" label="报名时间"></el-table-column>
        <el-table-column label="是否晋级">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.promotion == 1" style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 是</span
              >
              <span v-else style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 否</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.promotion == 1
                    ? setActivityPromotion(row.id, 0)
                    : setActivityPromotion(row.id, 1)
                "
              >
                {{ row.promotion == 1 ? "取消" : "晋级" }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
    
    <el-dialog title="图片" :visible.sync="dialogImg" width="70%">
      <template v-for="(img, key) in imgUrl">
        <el-image :src="img" v-bind:key="key">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImg = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="视频" :visible.sync="dialogVideo" width="70%">
      <video :src="videoUrl" width="500" controls ref="videoPlayer" ></video>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">关闭</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import {
  getMentorRegisterList,
  setActivityPromotion
} from "@/api/activity";

const axios = require('axios');

export default {
  data:function () {
    return {
      listData:[],
      listLoading:false,
      total:0,
      dialogImg:false,
      dialogVideo:false,
      imgUrl:'',
      videoUrl:'',
      query:{
        limit:10,
        page:1
      }
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      getMentorRegisterList(this.query).then(response => {
        this.listData = response.data.list
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    showImg(imgUrl){
      this.imgUrl = imgUrl;
      this.dialogImg = true;
    },
    downloadImg(imgUrl){
      // for(var i = 0; i < imgUrl.length; i++) {
      //   window.open(imgUrl[i], '_blank');
      // }
      var j = 0;
      //需要同时打开的网页
      var urlAll = imgUrl;

      function openTimer(nextIndex) {
        //便利完成则退出循环,并关闭当前页,并取消关闭提示
        if(nextIndex >= urlAll.length) {
          // window.opener = null;
          // window.open("about:blank", "_self");
          // window.close();
          return;
        };
        var urls = new Array();
        for(var i = 0; i < urlAll.length; i++) {
          urls[i] = urlAll[i];
        }
        
        var timeout = 100;
        //间隔时间（毫秒，1秒=1000毫秒）可以自行设置
        var winObj = window.open(urls[j], '_blank');
        setTimeout(function() {
          openTimer(++j)
        }, timeout);
      }

      openTimer(0);
    },
    showVideo(videoUrl){
      this.videoUrl = videoUrl;
      this.dialogVideo = true;
    },

    setActivityPromotion(id, promotion) {
      setActivityPromotion({
        id: id,
        promotion: promotion,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
      });
    },

    //导出
    exportList() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/activity/getMentorRegisterList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '讲师大赛学员列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    },
    closeDialog(){
      this.dialogVideo = false; // 关闭对话框
      this.$refs.videoPlayer.pause(); // 暂停视频播放
    }
  },
}
</script>
<style>
.el-button{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>